/**
 * Editor reutilizável de lista de strings como chips (Brief 4 · Tela 1 · PR4).
 * Usado para limites éticos (tópicos de redirecionamento) e outcomes de auto-close.
 * Adiciona via input + Enter/botão; remove via × na chip. Não duplica entradas.
 */

import { Plus, X } from 'lucide-react';
import { useState } from 'react';

export function ChipListEditor({
  values,
  onChange,
  placeholder,
  mono = false,
  ariaLabel,
}: {
  values: string[];
  onChange: (next: string[]) => void;
  placeholder: string;
  mono?: boolean;
  ariaLabel: string;
}): JSX.Element {
  const [pending, setPending] = useState('');

  const add = (): void => {
    const value = pending.trim();
    if (value === '' || values.includes(value)) {
      setPending('');
      return;
    }
    onChange([...values, value]);
    setPending('');
  };

  const remove = (value: string): void => {
    onChange(values.filter((v) => v !== value));
  };

  return (
    <div className="pb-chip-editor">
      {values.length > 0 && (
        <div className="pb-chip-row">
          {values.map((value) => (
            <span key={value} className={'pb-chip' + (mono ? ' pb-chip--mono' : '')}>
              {value}
              <button
                type="button"
                className="pb-chip__x"
                aria-label={`Remover ${value}`}
                onClick={() => {
                  remove(value);
                }}
              >
                <X size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="pb-chip-add">
        <input
          type="text"
          className={'pb-input' + (mono ? ' pb-input--mono' : '')}
          value={pending}
          placeholder={placeholder}
          aria-label={ariaLabel}
          onChange={(e) => {
            setPending(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add();
            }
          }}
        />
        <button type="button" className="pb-btn pb-btn--sm" onClick={add}>
          <Plus size={14} /> Adicionar
        </button>
      </div>
    </div>
  );
}
